export const environment = {
  production: true,
  name: "prod",
  title: "Pague com iClinic Pay",
  endpoints: {
    base_invoice_api_url: "https://o1defgai9b.execute-api.us-east-1.amazonaws.com/prod", // URL temporária para configuração do ambiente de produção
    base_api_url: "https://api.iclinicpay.com.br",
    receipt_url: "https://receipt.iclinicpay.com.br",
  },
  snowplow_collector_url: "https://br-com-pebmed-main.collector.snplow.net",
  snowplow_app_id: "iclinicpay_invoice",
  time_to_check: 10000,
  minimum_installment_value: 5,
  captcha_site_key: "6LeGODAkAAAAAJBbo2u_EsAN4a-MFuKbxKi1yIlp",
  captcha_card_number: ["4444444444444444", "4111111111111111"],
};
